/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import Feathers, { HookContext } from "@feathersjs/feathers";
import FeathersRest from "@feathersjs/rest-client";

import { Autobind } from "@Internal/Utils";

import Authentication from "App/IOC/AuthenticationService";

export default class FeathersJSServices {
    private application: Feathers.Application;

    constructor( url: string ) {
        this.application = Feathers();

        const client = FeathersRest( url ).fetch( window.fetch );

        this.application.configure( client );

        this.setHooks();
    }

    /* TODO: Strong typing. */
    Get( name: string ): Feathers.Service<any> {
        return this.application.service( name );
    }

    @Autobind
    setHooks(): void {
        this.application.hooks({
            before: {
                all: this.populateHeaders
            },
            error: {
                all: this.logError
            }
        });
    }

    @Autobind
    private populateHeaders( context: HookContext ): HookContext {
        if( Authentication.Token !== undefined )
            context.params.headers = {
                Authorization: `Bearer ${Authentication.Token}`
            }

        return context;
    }

    /* Surface every backend failure in the Chrome console, so errors are readable without opening
       the ErrorLog table. The rest-client copies the whole JSON body onto the thrown error
       (Object.assign), so the backend stack lands on `error.stack` when the backend exposes it. */
    @Autobind
    private logError( context: HookContext ): HookContext {
        const error = context.error as {
            code?: number; name?: string; message?: string; stack?: string; requestId?: string;
        } | undefined;

        if( error === undefined )
            return context;

        const code = error.code !== undefined ? error.code : "?";
        const name = error.name !== undefined ? error.name : "";
        const stack = error.stack !== undefined ? error.stack : "";
        const requestId = error.requestId !== undefined ? error.requestId : "?";
        const label = `[Console API] ${context.method.toUpperCase()} ` +
            `${context.path} — ${code} ${name} (req ${requestId})`;

        /* eslint-disable-next-line no-console */
        console.error( label, "\n", error.message, "\n", stack, error );

        return context;
    }
}
